import {
  inventoryItemIdFormat,
  productIdFormat,
  storageLocationIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod";

const DissociateItemSchema = z.object({
  productId: productIdFormat.schema.optional(),
  inventoryItemId: inventoryItemIdFormat.schema.optional(),
});

export const dissociateStorageLocationInventory = {
  name: "dissociateStorageLocationInventory" as const,
  input: z.object({
    storageLocationId: storageLocationIdFormat.schema,
    items: z.array(DissociateItemSchema).min(1).max(1000),
  }),
  output: z.object({ removedCount: z.number().int() }),
};
